import { memo } from "react";
import PropTypes from 'prop-types';


const BzSlider = ({ type, min, max, value, onChange, ...props }) => {
    return (
        <input
            min={min && max && value ? min : 0}
            max={min && max && value ? max : 100}
            value={min && max && value ? value : 50}
            onChange={onChange}
            className='BzSlider'
            // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
            type='range'
            step='0.0001'
            // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 
            {...props}
        />
    );
};

BzSlider.propTypes = {
    type: PropTypes.string,
    onChange: PropTypes.func,
    min: PropTypes.number,
    max: PropTypes.number,
    value: PropTypes.number,
};

BzSlider.defaultProps = {
    type: 'range',
    min: 0,
    max: 100,
};


export default memo(BzSlider);